<script>
  import {getContext} from 'svelte';
  import CoordinatorGeneralForm from '../forms/sponsor.general';
  import SectionNav from '../../../../components/navigation/section';
  import {addNotification, ICONS} from '../../../../utils/notifications.store';
  import {UPDATE_SPONSOR, ADD_SPONSOR} from '../../../../graphql/sponsors';
  export let value;

  const client = getContext('apollo');
  const history = getContext('history');

  async function save() {
    const input = {
      name: value.name,
      logo: value.logo
    }

    if(value.id) {
      input.id = value.id;
    }

    const variables = {
      input
    }

    try {
      addNotification({ icon: ICONS.LOADING, message:`Saving ${value.name}`});
      const response = await client.mutate({mutation: value.id ? UPDATE_SPONSOR :  ADD_SPONSOR, variables});
      addNotification({ time: 3000, message:`Successfully Saved ${value.name}`, icon: ICONS.SUCCESS});

      if(!value.id) {
        value.id = response.data.addSponsor.id
        history.push(`/sponsors/view/${response.data.addSponsor.id}`)
      }

    } catch (e) {
      addNotification({message: `Error Saving ${value.name}`, icon: ICONS.ERROR})
    }
    
  }
</script>

<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-9">
    <CoordinatorGeneralForm bind:value={value} />
  </div>
  <div class="cell small-12 medium-3">
    <SectionNav>
      <div on:click={save} class="save">
        {#if value.id}SAVE SPONSOR{/if}
        {#if !value.id}ADD SPONSOR{/if}
      </div>
    </SectionNav>
  </div>
</div>